import { render, staticRenderFns } from "./BodyguardInfo.vue?vue&type=template&id=455632bf&"
import script from "./BodyguardInfo.vue?vue&type=script&lang=js&"
export * from "./BodyguardInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports